import React, { useState, useContext, useEffect } from 'react'
import './custom-signature-full-screen.css'
import PixiContainer from '../../pures/signature-request-detail/PixiContainer'
import { Context } from '../../../Context';
import SigantureImgData from "./siganture-img-data"

export default function CustomSignatureFullScreen(props) {
    const { setShowSignatureCanvas } = useContext(Context);
    const { newImg, imgSignature, pagesImgs, numPages, pagesSize, dataItem, greyText, widthImgSignature, heightImgSignature, back, save, signatures } = props
    const { innerWidth: fullWidth, innerHeight: fullHeight } = window;
    const [pager, setPager] = useState(props.pager ?? 1)
    const [pageNumber, setPageNumber] = useState(props.pageNumber ?? 1)
    const changePage = (offset) => {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
        setPager(prevPageNumber => prevPageNumber + offset)
    }
    useEffect(() => {
        if (props.visibleDialogTimerSignOff) {
            back()
            setShowSignatureCanvas(false)
        }
    }, [props.visibleDialogTimerSignOff])

    const previousPage = () => {
        if (pageNumber <= 1) return
        changePage(-1);
    }

    const nextPage = () => {
        if (pageNumber >= numPages) return
        changePage(1);
    }

    return (
        <div class="grid-container" style={{ width: fullWidth, height: fullHeight }}>
            <div style={{ position: 'fixed', right: 0, left: 0, top: 0, backgroundColor: 'white' }} >
                <div class="greyTexy">
                    <p
                        style={{
                            margin: '0px',
                            padding: '15px 35px 15px 35px',
                            fontStyle: 'italic',
                            fontSize: 'smaller'
                        }} >
                        {greyText}
                    </p>
                </div>

                <div class="controlBtns"  >
                    <span class="k-icon k-i-arrow-double-60-left icon-bar" onClick={() => {
                        setPageNumber(1);
                        setPager(1)
                    }} ></span>
                    <span class="k-icon k-i-arrow-60-left icon-bar" onClick={previousPage} ></span>
                    <div className="pagec" style={{ color: '#427FBA', textAlign: 'left', fontWeight: 'bold', marginTop: 'auto', marginBottom: 'auto', padding: '0px 5px' }}>
                        Página
                        <input style={{ width: '32px', marginLeft: '4px', marginRight: '3px' }} type="text" value={pager} onChange={({ target }) => {
                            setPager(Number(target.value))
                            if (Number(target.value) <= numPages) {
                                if (Number(target.value) <= 0) {
                                    setPageNumber(1);
                                    setPager(1)
                                } else setPageNumber(Number(target.value))
                            } else setTimeout(() => {
                                setPager(pageNumber)
                            }, 1000)
                        }} />
                        de {numPages || '--'}
                    </div>
                    <span class="k-icon k-i-arrow-60-right icon-bar" onClick={nextPage}></span>
                    <span class="k-icon k-i-arrow-double-60-right icon-bar" onClick={() => {
                        setPageNumber(numPages)
                        setPager(numPages)
                    }} ></span>
                </div>

            </div>

            <div class="document">
                {pagesImgs.map((item, index) => {
                    let fullwidth = pagesSize[index]?.width
                    let fullheight = pagesSize[index]?.height
                    let widthFull = fullwidth > fullWidth ? fullWidth : fullwidth
                    let percentage = (widthFull * 100) / fullwidth
                    let heightFull = (percentage / 100) * fullheight
                    SigantureImgData.percentage = percentage
                    SigantureImgData.percentage = percentage
                    SigantureImgData.widthImgSignature = ((widthImgSignature * (percentage / 100)) / 2) * 0.8
                    SigantureImgData.heightImgSignature = ((heightImgSignature * (percentage / 100)) / 2) * 0.8
                    SigantureImgData.widthCanvas = widthFull - 4
                    SigantureImgData.heightCanvas = heightFull
                    SigantureImgData.fullwidth = fullwidth
                    SigantureImgData.fullheight = fullheight
                    return (
                        <React.Fragment key={String(index)}>
                            <div style={index === pageNumber - 1 ? { marginTop: '64px', marginBottom: '32px' } : { display: 'none' }} >
                                <PixiContainer
                                    widthFull={SigantureImgData.widthCanvas}
                                    heightFull={SigantureImgData.heightCanvas}
                                    widthImgSignature={SigantureImgData.widthImgSignature}
                                    heightImgSignature={SigantureImgData.heightImgSignature}
                                    item={item}
                                    page={pageNumber}
                                    signatures={signatures}
                                    imgSignature={imgSignature}
                                    dataItem={dataItem}
                                    newImg={newImg}
                                />
                            </div>
                        </React.Fragment>
                    )
                })}
            </div>
            <div style={{ position: 'fixed', right: 0, left: 0, bottom: 0, display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }} >
                <div class="back">
                    <span
                        onClick={() => {
                            back()
                            setShowSignatureCanvas(false)
                        }}
                    >
                        {'Cancelar'}
                    </span>
                </div>
                <div class="save">
                    <span
                        onClick={() => setTimeout(() => {
                            let {
                                fullwidth: width,
                                fullheight: height,
                            } = SigantureImgData
                            let sendData = {
                                page: pageNumber,
                                x: ((SigantureImgData.x - (SigantureImgData.widthImgSignature * 0.5)) * width) / SigantureImgData.widthCanvas,
                                y: height - ((SigantureImgData.y + (SigantureImgData.heightImgSignature * 0.5)) * height) / SigantureImgData.heightCanvas,
                                width: (SigantureImgData.widthImgSignature * width) / SigantureImgData.widthCanvas,
                                height: (SigantureImgData.heightImgSignature * height) / SigantureImgData.heightCanvas,
                                isMobile: true,
                                sigantureImgData: SigantureImgData,
                                newImg
                            }
                            save(sendData)
                        }, 1)}
                    >
                        {'Capturar Firma'}
                    </span>
                </div>
            </div>

        </div >
    )
}